module.exports = __webpack_public_path__ + "static/media/inverted-dice-2.cb8dec1c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/inverted-dice-2.svg
// module id = 76
// module chunks = 0